import { render, staticRenderFns } from "./ViewBook.vue?vue&type=template&id=f2fee374&scoped=true"
import script from "./ViewBook.vue?vue&type=script&lang=js"
export * from "./ViewBook.vue?vue&type=script&lang=js"
import style0 from "./ViewBook.vue?vue&type=style&index=0&id=f2fee374&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fee374",
  null
  
)

export default component.exports